import { Alert as MuiAlert } from "@mui/material";
import type { AriaRole, PropsWithChildren, ReactNode } from "react";

type Severity = "error" | "info" | "success" | "warning";

type Props = PropsWithChildren<{
  severity?: Severity;
  "aria-labelledby"?: string;
  role?: AriaRole;
  icon?: ReactNode;
}>;

export const Alert = ({
  severity = "success",
  "aria-labelledby": ariaLabelledby,
  role = "alert",
  icon,
  children,
}: Props) => {
  return (
    <MuiAlert
      severity={severity}
      aria-labelledby={ariaLabelledby}
      role={role}
      icon={icon}
      sx={{ alignItems: "center" }}
    >
      {children}
    </MuiAlert>
  );
};
